<template>
  <div>
    <list-header></list-header>

    <template
      v-for="payment in cash.payments"
      >
      <payment-card
        :key="payment.id"
        :payment="payment"
        ></payment-card>
      <v-divider></v-divider>
    </template>

    <div
      class="text-right font-weight-medium body-2 pt-3"
      >
      Saldo inicial: {{ price(cash.amount) }}
    </div>

    <div
      class="text-right font-weight-bold body-1 py-3"
      >
      <div
        class="d-flex justify-end"
        style="gap: 12px"
        >
        <span
          class="font-weight-bold"
          >
          Total: 
        </span>

        <div
          class="text-right"
          style="width: 120px"
          >
          <div
            v-for="payment in Object.entries(total)"
            v-if="payment[1]"
            >
            {{ price(payment[1], payment[0]) }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-right"
      v-if="currentUser.displayRoles.includes('admin')"
      >
      <v-btn
        :disabled="cash.state != 'closed'"
        color="primary"
        depressed
        @click="approveCash"
        >
        {{ cash.state == 'closed' ? 'Aprobar' : 'Caja aprobada' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EditCashRegister } from '@/graphql/mutations/cash_registers'

const PaymentCard = () => import('@/components/payments/general/Card')
const ListHeader = () => import('@/components/payments/general/Header')

export default {
  data: () => ({
    total: {
      "ARS": 0,
      "USD": 0
    }
  }),

  props: {
    cash: {
      type: Object,
      required: true
    }
  },

  created () {
    this.total = {
      "ARS": 0,
      "USD": 0
    }
    this.cash.payments.forEach( payment => {
      this.total[payment.currency] += payment.lastingAmount
    })
  },

  computed: {
    ...mapGetters(['currentUser']),
  },

  methods: {
    price (amount, currency = "ARS") {
      const options = { style: 'currency', currency: currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },

    approveCash () {
      this.$apollo.mutate({
        mutation: EditCashRegister,
        variables: {
          input: {
            id: this.cash.id,
            attributes: {
              state: 'accepted'
            }
          }
        }
      }).then ( res => {
        this.$emit ('reload')
      })
    },
  },

  components: {
    PaymentCard,
    ListHeader,
  }
}
</script>
